import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/ArrowsDownUp.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...e, weights: n }));
r.displayName = "ArrowsDownUpIcon";
const p = r;
export {
  p as ArrowsDownUp,
  r as ArrowsDownUpIcon
};
